<template>
  <div class="layout">
    <header v-if="header" />
    <div class="main">
      <img :src="`${STATIC_PATH}/img/icons/daicho-icon.png`" class="icon" />
      <p class="bold-text summary">{{ summary() }}</p>
      <slot name="description">
        <p class="small-text description">{{ description() }}</p>
      </slot>
      <div v-if="!noGuide" class="guide">
        <span class="bold-text">{{ guideText(1) }}</span>
        <span>{{ guideText(2) }}</span>
        <span class="small-text">{{ guideText(3) }}</span>
      </div>
      <Button v-if="showLogin" @click="onSubmit">ログイン画面に戻る</Button>
    </div>
  </div>
</template>

<script>
import Button from '@/components/atoms/Button'
import { mapState } from 'vuex'

const ERROR = 1
const MAINTENANCE = 2
const STOP = 3

export default {
  name: 'Error',
  components: {
    Button,
  },
  props: {
    backTo: String,
    header: { type: Boolean, default: true },
    hideLogin: { type: Boolean, default: false },
  },
  data() {
    return {
      STATIC_PATH,
    }
  },
  computed: {
    ...mapState({
      optional: state => state.optional,
    }),
    noGuide() {
      return this.optional.errorType === ERROR || !this.optional.maintePeriod
    },
    showLogin() {
      return this.optional.errorType === STOP && !this.hideLogin
    },
  },
  methods: {
    summary() {
      return new Map([
        [ERROR, 'エラーが発生しました'],
        [MAINTENANCE, '現在メンテナンス中です'],
        [STOP, 'ご利用いただけない状態になっております'],
      ]).get(this.optional.errorType)
    },
    description() {
      return new Map([
        [ERROR, '大変申し訳ありません。エラーが発生しました。\nしばらくしてから再度ご利用ください。'],
        [MAINTENANCE, '只今メンテナンス中のため、\nサービスをご利用いただけません。'],
        [
          STOP,
          '恐れ入りますが、担当営業、もしくはぐるなびカスタマー\nサポートサービスまでご連絡いただけますよう、\nお願いいたします。',
        ],
      ]).get(this.optional.errorType)
    },
    guideText(line) {
      return [
        new Map([
          [MAINTENANCE, 'メンテナンス期間'],
          [STOP, 'ぐるなびサポートセンター'],
        ]),
        new Map([
          [MAINTENANCE, this.optional.maintePeriod + '（予定）'],
          [STOP, '0120-22-9672'],
        ]),
        new Map([
          [MAINTENANCE, 'メンテナンス終了時間は変更になることがあります。'],
          [STOP, '営業時間：平日 10：00 〜 18：00'],
        ]),
      ][line - 1].get(this.optional.errorType)
    },
    async onSubmit() {
      if (await this.$store.dispatch('app/logout')) {
        window.location.href = '/sp/login'
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

header {
  background: var(--moderate-blue);
  height: 56px;
  width: 100%;
}

.main {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  padding: 0 16px;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.icon {
  height: 64px;
  width: 64px;
}

.summary {
  line-height: 0.9;
  margin-top: 17px;
}

.description {
  margin-top: 13px;
  text-align: center;
}

.guide {
  border: solid 1px var(--border-color);
  box-sizing: border-box;
  display: grid;
  grid-gap: 8px;
  margin-top: 16px;
  padding: 24px 16px;
  width: 100%;
}

.button {
  font-size: 15px;
  height: 40px;
  line-height: 38px;
  margin-top: 24px;
  text-align: center;
  width: 100%;
}

.bold-text {
  font-weight: 600;
}

.small-text {
  font-size: 13px;
}
</style>
